import { memo, useMemo } from 'react';

import { merge } from '@/components';
import { Heading } from '@/components/core';
import { useDots } from '@/hooks';
import { useDocumentStore } from '@/store';
import { DivProps } from '@/utils';

import { AIModelMenu } from './AIModelMenu';
import { KnowledgeMenu } from './KnowledgeMenu';

export type DocumentFormHeaderProps = Omit<DivProps, 'children'>;

const IDocumentFormHeader = ({ className, ...rest }: DocumentFormHeaderProps) => {
  const status = useDocumentStore((state) => state.status);

  const dots = useDots();

  const heading = useMemo(() => {
    let heading;
    switch (status) {
      case 'error':
      case 'ready-for-review':
      case 'review-in-progress':
      case 'completed':
      case 'exported':
        heading = 'AI response';
        break;
      default:
        heading = `AI is working ${dots}`;
    }
    return heading;
  }, [dots, status]);

  return (
    <div className={merge('gap-sm px-md flex items-center', className)} {...rest}>
      <Heading size="sm">{heading}</Heading>
      <div className="grow" />
      <KnowledgeMenu />
      <AIModelMenu />
    </div>
  );
};

export const DocumentFormHeader = memo(IDocumentFormHeader) as typeof IDocumentFormHeader;
